import React from "react";
import { QuestionContext } from "../../context";

import { QuestionMultiChoice } from "../QuestionMultiChoice";
import { QuestionJudge } from "../QuestionJudge";
import { QuestionFill } from "../QuestionFill";
import { QuestionMixed } from "../QuestionMixed";
import { QuestionSingleChoice } from "../QuestionSingleChoice";
import { QuestionSubject } from "../QuestionSubject";
import classNames from "classnames";

interface QuestionProps extends RenderComponent {
    type: QuestionType;
    data: Partial<QuestionData[QuestionType]>;
    renderSubQuestion?: (index: number, data: any) => React.ReactNode;
}

export function Question({
    type,
    data,
    children,
    className,
    style,
    renderSubQuestion
}: QuestionProps) {
    return (
        <QuestionContext.Provider
            value={{ type, data, renderSubQuestion } as any}>
            <div className={classNames("Question", className)} style={style}>
                {type === "SingleChoice" && <QuestionSingleChoice />}
                {type === "MultiChoice" && <QuestionMultiChoice />}
                {type === "Judge" && <QuestionJudge />}
                {type === "Fill" && <QuestionFill />}
                {type === "Subjective" && <QuestionSubject />}
                {type === "Mixed" && <QuestionMixed />}

                {children}
            </div>
        </QuestionContext.Provider>
    );
}
